import { IncidentReportHistory } from '../../components/incidentReports'
import { setNavLink, unsetNavLink } from '../../actions/nav'
import { NAV_LINKS } from '../../constants/NavConstants'

const IncidentReportHistoryPage = ({ setNavLink, unsetNavLink, selectedIsCurrent }) => {
  useEffect(() => {
    setNavLink(NAV_LINKS.students, 'Back to Students')
    return () => unsetNavLink()
  }, [])

  return (
    <CSSTransition
      classNames="animate-fade"
      in={true}
      timeout={500}
      appear={true}
      enter={false}
      exit={false}
    >
      <div className="container">
        <h2>Incident Report Submission History</h2>
        <IncidentReportHistory />
      </div>
    </CSSTransition>
  )
}

export default connect(null, { setNavLink, unsetNavLink })(IncidentReportHistoryPage)
